import { Component, OnInit, OnDestroy } from '@angular/core';
import { SearchParams } from '../../../../shared/search/models/search-params.model';
import { SearchStatus } from '../../../../shared/search/models/search-status.model';
import { AlertService } from 'sce-core';
import { SearchCriteria, Condition } from '../../../../shared/search/models/search-filter-model';
import { SearchService } from '../../../../shared/search/search.service';
import { ServerPagedTableService } from '../../../../shared/services/table/server-paged-table.service';
import { ResourceService } from 'sce-core';
import { Subscription } from 'rxjs/Subscription';
import { DATA_TABLE_LIST } from '../service/inventory-balance-tables';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { DataTableConfig } from '../../../../shared/search/models/data-table-config';
import { SearchEvent } from '../../../../shared/search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../../../shared/search/search-constants';
import { PagedData } from '../../../../shared/search/models/paged-data.model';
import { TableRow } from '../../../../shared/search/models/table-row.model';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ModalService } from '../../../../shared/services/modal.service';

@Component({
  selector: 'lfwms-invlookup-popup',
  templateUrl: './invLookup-popup.component.html',
  styleUrls: ['./invLookup-popup.component.css']
})
export class InvLookupComponent implements OnInit, OnDestroy {

  private lookupParams: SearchParams;
  public lookupStatus: SearchStatus;
  public lookupService: SearchService;
  public lookupAlertService: AlertService;
  public showLookup: boolean;
  public title: string;
  public tableService: ServerPagedTableService;
  private eventSubscription: Subscription;
  public dataTablesList: any;
  public type;
  public selectedValue;
  public selectedViewType;
  private searchEventSubject = new Subject<SearchEvent>();
  public mainMetaData: any;
  public selectedRows: any;

  constructor(public modalService: ModalService,
      private resourceService: ResourceService,
      private coreServiceRegistry: CoreServiceRegistry,
      private sharedServiceRegistry: SharedServiceRegistry) {
    this.lookupAlertService = new AlertService();
  }

  public ngOnInit() {
    this.dataTablesList = DATA_TABLE_LIST;
  }

  /*This method will initialize services for lookup component */
  public initializeComponents(selectedRows: any, searchService: SearchService, mainMetaData: any) {
    this.mainMetaData = mainMetaData;
    this.selectedRows = selectedRows;
    this.lookupParams = searchService.searchParams;
    this.lookupParams.alertService = this.lookupAlertService;
    this.lookupService = searchService;
    this.lookupService.searchParams = searchService.searchParams;
    this.lookupStatus = this.lookupService.searchStatus;
    this.lookupService.searchStatus = searchService.searchStatus;
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    this.lookupService.fetchMetadata().subscribe((metadata: any) => {
      const toSearchCriteria: SearchCriteria = this.getSearchCriteriaForPopup(selectedRows, this.mainMetaData, metadata);
      this.lookupService.setSearchCriteria(toSearchCriteria);
      this.lookupService.searchParams.isFullFetch = true;
      this.fetchResults();
    });
  }

  public receiveEvent(): Observable<SearchEvent> {
    return this.searchEventSubject.asObservable();
  }

  public fetchResults() {
    this.lookupAlertService.clearAll();
    this.lookupService.fetchSearchResults()
      .subscribe((data: any) => {
        this.lookupService.searchStatus.hasResults = true;
        this.lookupService.searchStatus.recordCount = this.lookupService.pagedData.pageDefinition.recordCount;
        const event = new SearchEvent(NEW_SEARCH_EVENT);
        event.isSearchSuccess = true;
        this.lookupService.publishEvent(event);
      }, (error: any) => {
        this.lookupService.pagedData = new PagedData<TableRow>();
        this.lookupService.pagedData.pageRows = [];
        this.lookupService.searchStatus.hasResults = true;
        this.lookupService.searchStatus.recordCount = this.lookupService.pagedData.pageDefinition.recordCount;
        const event = new SearchEvent(NEW_SEARCH_EVENT);
        event.isSearchSuccess = true;
        this.lookupService.publishEvent(event);
      });
  }

  public handleViewChange(selectedViewType: string) {
    this.loadResultDataForType(selectedViewType);
  }

  private loadResultDataForType(type: string) {
    this.lookupService = this.getResultSearchServiceForViewType(type);
    this.lookupParams = this.lookupService.searchParams;
    this.lookupStatus = this.lookupService.searchStatus;
    this.lookupStatus.hasResults = false;
    this.lookupService.fetchMetadata().subscribe((metadata: any) => {
      this.lookupService.searchParams.isFullFetch = true;
      this.lookupAlertService.clearAll();
      this.lookupService.searchCriteria = this.getSearchCriteriaForPopup(this.selectedRows, this.mainMetaData, metadata);
      this.fetchResults();
    });
  }

  private getResultSearchServiceForViewType(type: string): SearchService {
    let searchService: SearchService;
    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = type;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    const searchStatus = new SearchStatus();
    searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    return searchService;
  }

  public createSearchCondition(id) {
    const searchCondition = new Condition();
    searchCondition.id = id;
    searchCondition.displayMode = 'VIEW';
    return searchCondition;
  }

  public getLabel(key) {
    return this.resourceService.get(key);
  }

  public ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  public getSearchCriteriaForPopup(selectedRows: any, metaDataMain, metaData: any): SearchCriteria {
    const dataMap = new Map();
    const filterCriteria = new SearchCriteria();
    const finalListFields = this.filterSearchCriteria(metaDataMain, metaData);
    selectedRows.forEach((row: any) => {
      Object.keys(row.cells).forEach((property: any) => {
        const cell = row.cells[property];
        dataMap.set(property, cell.cValOrig);
      });
    });

    // tslint:disable-next-line:prefer-const
    let conditionsArray: Array<any> = [];
    finalListFields.forEach(element => {
      const value = dataMap.get(element);
      let valueTrimmed: any;
      if (value) {
        valueTrimmed = value.trim();
      }
      if (value && (valueTrimmed.length !== 0)) {
        const condition: any = {
          'isMandatory': false,
          'displayMode': 'VIEW',
          'id': element,
          'clauses': [
            {
              'column': element,
              'operation': '=',
              'value': valueTrimmed,
              'value1': '',
              'logicalOperation': null
            }],
          'operator': 'AND'
        };
        conditionsArray.push(condition);
      }
    });
    if (conditionsArray.length > 0) {
      conditionsArray[conditionsArray.length - 1].operator = 'null';
    }
    Object.assign(filterCriteria.conditions, conditionsArray);
    return filterCriteria;
  }


  //  This is to send only the common fields by comparing the metadata of
  //  column selected and the dropdown change
  public filterSearchCriteria(metaDataMain, metadata): any {
    // tslint:disable-next-line:prefer-const
    let commonProperties: Array<any> = [];
    // tslint:disable-next-line:prefer-const
    let metaDataArray: Array<any> = [];
    // tslint:disable-next-line:prefer-const
    let mainMetaDataArray: Array<any> = [];
    const metaDataMainTable: any = metaDataMain.columnList;
    const metaDataPopupTable: any = metadata.columnList;
    metaDataMainTable.forEach((element: any) => {
      mainMetaDataArray.push(element.propertyName);
    });
    metaDataPopupTable.forEach((element: any) => {
      metaDataArray.push(element.propertyName);
    });
    for (let i = 0; i < metaDataMainTable.length; i++) {
      for (let j = 0; j < metaDataPopupTable.length; j++) {
        const propertyMainTable = metaDataMainTable[i]['propertyName'];
        const propertyPopupTable = metaDataPopupTable[j]['propertyName'];
        const displaytypeofPropertyMainTable = metaDataMainTable[i]['displayType'];
        const displaytypeofPropertyPopUpTable = metaDataPopupTable[j]['displayType'];
        if ((propertyMainTable === propertyPopupTable) && (displaytypeofPropertyMainTable !== 'H')
          && (displaytypeofPropertyPopUpTable !== 'H')) {
          commonProperties.push(propertyMainTable);
          break;
        }
      }
    }
    return commonProperties;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/control/inventory-balance/popup/invLookup-popup.component.ts